import { genericConstants } from "../constants";

const initialState = {
    loading: false,
    error: null,
    items: null,
    CaptureData: []
};

export const IndentificationCaptureData = (state = initialState, action) => {
    if (action.type == genericConstants.ADD_IDENTIFICATION_DATA_SUCCESS) {
        console.log("IndentificationCaptureData----------------------------*********-------: ", action.payload)
        return {
            ...state,
            CaptureData: action.payload,
        };
    } else {
        return state; //Retornar state vacío o actual
    }
};

export const AddTitleLegoData = (state = initialState, action) => {
    if (action.type == genericConstants.ADD_TITLE_LEGO_CURRENT_SUCCESS) {
        return {
            ...state,
            Title: action.payload,
        };
    } else {
        return state; //Retornar state vacío o actual
    }
};
export const SetDefualtLanguage = (state = initialState, action) => {
    if (action.type == genericConstants.SET_DEFAULT_LANGUAGE) {
        return {
            ...state,
            lang: action.payload,
        };
    } else {
        return state; //Retornar state vacío o actual
    }
};